import { render, staticRenderFns } from "./PagoForm.vue?vue&type=template&id=ab22a060&scoped=true"
import script from "./PagoForm.vue?vue&type=script&lang=js"
export * from "./PagoForm.vue?vue&type=script&lang=js"
import style0 from "./PagoForm.vue?vue&type=style&index=0&id=ab22a060&prod&lang=css"
import style1 from "./PagoForm.vue?vue&type=style&index=1&id=ab22a060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab22a060",
  null
  
)

export default component.exports